const marques = [
  { name: "Nice", desc: "Électrification avec moteurs Era, Roll et Era Inn" },
  { name: "Somfy", desc: "Motorisation et points de commande io/RTS" },
];

export default function Marques() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="text-[#1B2A4A] text-2xl md:text-3xl font-extrabold text-center mb-3">
          Marques installées
        </h2>
        <p className="text-[#2F4A63] text-base text-center mb-10 md:mb-14">
          Spécialistes des moteurs Nice Era et Roll, nous proposons aussi les motorisations Somfy io et RTS pour les installations domotiques.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 max-w-2xl mx-auto">
          {marques.map((marque) => (
            <div
              key={marque.name}
              className="bg-[#F5F2EB] rounded-xl border border-[#E2E8F0] p-5 md:p-6 text-center hover:border-[#E8734A]/40 transition-colors"
            >
              <p className="text-[#1B2A4A] font-bold text-base md:text-lg mb-1">{marque.name}</p>
              <p className="text-[#2F4A63] text-xs">{marque.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}